import { Suspense, lazy, useEffect } from "react";
import { Library } from "./screens/Library";

// Главный экран — в основном бандле, остальные подгружаются по требованию (и предкэшируются SW)
const ComposeScreen = lazy(() => import("./screens/Compose").then((m) => ({ default: m.ComposeScreen })));
const Player = lazy(() => import("./screens/Player").then((m) => ({ default: m.Player })));
const SettingsScreen = lazy(() => import("./screens/Settings").then((m) => ({ default: m.SettingsScreen })));
const TrainersScreen = lazy(() => import("./screens/Trainers").then((m) => ({ default: m.TrainersScreen })));
const HistoryScreen = lazy(() => import("./screens/History").then((m) => ({ default: m.HistoryScreen })));
const WorkingScreen = lazy(() => import("./screens/Working").then((m) => ({ default: m.WorkingScreen })));
import { back, navigate, useRoute } from "./lib/router";
import { initTelegram, setTelegramBack, startParam } from "./lib/telegram";
import { applyTheme, watchSystemTheme } from "./lib/theme";

let booted = false;

export function App() {
  const route = useRoute();

  useEffect(() => {
    if (booted) return;
    booted = true;
    initTelegram(back);
    applyTheme();
    watchSystemTheme();
    const sp = startParam();
    const m = sp && /^play_([0-9a-f-]{36})$/.exec(sp);
    if (m) navigate({ name: "play", id: m[1]! }, { replace: true });
  }, []);

  useEffect(() => {
    setTelegramBack(route.name !== "library" && route.name !== "trainers");
    window.scrollTo(0, 0);
  }, [route.name]);

  return <Suspense fallback={<main className="screen" aria-busy="true" />}>{screen(route)}</Suspense>;
}

function screen(route: ReturnType<typeof useRoute>) {
  switch (route.name) {
    case "library":
      return <Library />;
    case "new":
      return <ComposeScreen />;
    case "edit":
      return <ComposeScreen setId={route.id} />;
    case "play":
      return <Player id={route.id} />;
    case "settings":
      return <SettingsScreen />;
    case "trainers":
      return <TrainersScreen />;
    case "history":
      return <HistoryScreen />;
    case "working":
      return <WorkingScreen key={route.id} id={route.id} />;
  }
}
